import React from 'react';

import { Page } from './components';
import { useTaskTablesContext } from './context';

export const TaskTables: React.FC = React.memo(function TaskTables() {
  return (
    <useTaskTablesContext.Provider>
      <Page />
    </useTaskTablesContext.Provider>
  );
});

export { TaskTableSearchParams } from './types';
